export default class Group {
  constructor(object) {
    this.id = (object && parseInt(object.id, 10)) || null
    this.parentId = (object && parseInt(object.parent_id, 10)) || null
    this.name = (object && object.name) || null
    this.label1 = (object && object.label1) || null
    this.label2 = (object && object.label2) || null
    this.label3 = (object && object.label3) || null
    this.token = (object && object.token) || null
    this.depth = (object && object.depth) || null
    this.isRoot = (object && parseBoolean(object.is_root)) || null
    this.isLeaf = (object && parseBoolean(object.is_leaf)) || null
    this.managersCount = (object && parseInt(object.managers_count, 10)) || 0
    this.recruitersCount = (object && parseInt(object.recruiters_count, 10)) || 0
    this.enrolledCount = (object && parseInt(object.enrolled_count, 10)) || 0
  }

  static fromJson(json) {
    if (!json) {
      return null
    }

    return new Group(json)
  }

  isEqual(group) {
    if (!group) {
      return false
    }

    return this.id === group.id
  }
}
